export const navbarConstants = {
  GET_SEARCH_RESULTS_FAILURE: "GET_SEARCH_RESULTS_FAILURE",
  GET_SEARCH_RESULTS_SUCCESS: "GET_SEARCH_RESULTS_SUCCESS",

  GET_SEARCH_QUERY_FAILURE: "GET_SEARCH_QUERY_FAILURE",
  GET_SEARCH_QUERY_SUCCESS: "GET_SEARCH_QUERY_SUCCESS",

  SEARCH_RESET: "SEARCH_RESET",
};
